import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.black3};
  background: ${({ theme }) => theme.colors.white};
`;

export const ContentWrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  padding: 16px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const CardsWrapper = styled.div`
  display: none;

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
  }
`;

export const MobileCarouselWrapper = styled.div`
  display: block;
  width: 100%;
  padding-bottom: 8px;

  && .slick-dots {
    position: static;
    margin: 8px 0 0;
  }

  && .slick-dots li {
    margin: 0 4px;
  }

  && .slick-dots li button::before,
  && .slick-dots li.slick-active button::before,
  && .slick-dots li button::after,
  && .slick-dots li.slick-active button::after {
    display: none !important;
    content: none !important;
  }
  && .slick-dots li::after {
    position: static !important;
  }
  && .slick-dots li button {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.black2};
    border: 0;
    padding: 0;
    opacity: 1;
    transition: background-color 0.2s ease;
    overflow: visible;
  }

  && .slick-dots li.slick-active button {
    background: ${({ theme }) => theme.colors.black9};
  }
  && .slick-dots li {
    overflow: visible !important;
  }
  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    display: none;
  }
`;
